import { render, staticRenderFns } from "./taperedRule.vue?vue&type=template&id=49311a12&"
import script from "./taperedRule.vue?vue&type=script&lang=js&"
export * from "./taperedRule.vue?vue&type=script&lang=js&"
import style0 from "./taperedRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports